import React, { ReactNode } from "react";
import { Card, Collapse } from "react-bootstrap";

//ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);
interface ICollapseCard {
	header: ReactNode;
	headerRight: ReactNode;
	body: ReactNode;
	id: string;
	className: string;
	state: boolean;	// true: visible/uncollapsed, false: collapsed
	collapsible: boolean;
	onFinishAnimation?: () => void,
	onChangeState?: () => void,
}

export const CollapseCard = (props: ICollapseCard) => {

	const click = () => {
		props.onChangeState();
	};

	if (props.collapsible) {
		return (
			<Card key={props.id} id={props.id} className={props.className} >
				<Card.Header className="d-flex justify-content-between" onClick={click}>
					{props.header}
					{props.headerRight && <div className="schema-engine-card-action-buttons">{props.headerRight}</div>}
					<a className="text-dark" onClick={click}>
						{props.state ? <i className="fa-regular fa-chevron-up fa-lg" /> : <i className="fa-regular fa-chevron-down fa-lg" />}
					</a>
				</Card.Header>
				<Collapse in={props.state} onEntered={props.onFinishAnimation} onExited={props.onFinishAnimation}>
					<Card.Body>
						{props.body}
					</Card.Body>
				</Collapse>
			</Card>
		);
	} else {
		/**
		 * If the card is not collapsible, we use a simple card with a header and body. But here also we check if there
		 * is a header or not. If there is no header, we make a "body-only" card. In this case, if there is a headerRight
		 * element, we put it in the top-right corner of the card in a fixed position. This allows this card to be used for title
		 * less dashboard cards.
		 */
		return (
			<Card key={props.id} id={props.id} className={props.className} >
				{(props.headerRight && !props.header) && <div className="schema-engine-card-top-right-control">{props.headerRight}</div>}
				{props.header && 
					<Card.Header className="d-flex justify-content-between">
						{props.header}
						{props.headerRight && <div className="schema-engine-card-action-buttons">{props.headerRight}</div>}
					</Card.Header>
				}
				<Card.Body>{props.body}</Card.Body>			
			</Card>
		);
	}
};

export default CollapseCard;
